import { UseFormRegisterReturn } from 'react-hook-form'

type InputProps = {
    type: string
    label: string
    id:string
    className?: string
    placeholder?: string
    required: boolean
    autoComplete?: string
    registration: Partial<UseFormRegisterReturn>
}

const Input = (Props:InputProps) => {
    return(
        <div>
            <label htmlFor={Props.id} className={"flex items-center text-sm font-medium"}>{Props.label}{Props.required && (<span className={"ml-2 text-xs text-danger"}>必須</span>)}</label>
            <input
                type={Props.type}
                id={Props.id}
                className="mt-2 min-h-[56px] bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
                placeholder={Props.placeholder}
                {...Props.registration}
            />
        </div>
    )
}

export default Input